import { Menu } from "../../resolvers-types";
import { ngEditorMenu } from "../sampleData/ngEditorMenu";
import { callServiceLight, getState } from "./dataService";
import { log } from "./logger";
import { RuntimeContext } from "./NGFieldExtensions";
const tag = "Menu";

async function GetMenuFromBackend(menuId: string, context: RuntimeContext) {
  log.info(tag, "Service request", "project.menu.get");
  const resp = await callServiceLight({ Name: "project.menu.get", Service: "project.menu.get" }, { Id: menuId }, context);
  if (!resp?.success) {
    return false;
  }

  return resp?.data.Entity;
}

async function GetDefaultMenu(context: RuntimeContext) {
  const resp = (await GetMenuFromBackend("default", context)) as Menu;
  if (!resp) {
    return false;
  }

  return resp;
}

async function GetUserMenu(userProfile, context: RuntimeContext) {
  const userMenuId = userProfile?.Details?.MenuId;
  if (!userMenuId) {
    log.warn(tag, "User does not have a menu assigned. Using default menu.");
    return GetDefaultMenu(context);
  }

  // If the user did have an assigned menu, get it
  const menuResp = (await GetMenuFromBackend(userMenuId, context)) as Menu;
  if (!menuResp) {
    log.error(tag, "GetMenuFromBackend failed", menuResp);
    return false;
  }

  log.info(tag, "GetUserMenu returned menu Id", userMenuId);
  return menuResp;
}

async function GetMenu(userProfile, context: RuntimeContext) {
  const { global } = getState(context);
  const menuMetadata = await GetUserMenu(userProfile, context);
  if (!menuMetadata) {
    log.error(tag, `Failed to get menu for user profile: ${JSON.stringify(userProfile)}`);
    return ngEditorMenu as Menu;
  }
  log.info(tag, "Menu", menuMetadata);
  global.Menu.value = menuMetadata;
  return menuMetadata;
}

export async function setupMenu(userProfile, context: RuntimeContext) {
  const menu = await GetMenu(userProfile, context);
  return menu;
}